"use strict";

var _excluded = ["marketingSource"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback } from 'react';
import { useFlixApiContext } from '../../FlixApiContext';
import { REGISTERED } from '../../eventsNames';
import { writeAuthStatusQuery } from '../AuthStatus/authStatus';
export var useRegisterMutation = function useRegisterMutation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onCompleted = _ref.onCompleted;

  var _useFlixApiContext = useFlixApiContext(),
      client = _useFlixApiContext.client,
      flixApiV2 = _useFlixApiContext.flixApiV2,
      events = _useFlixApiContext.events;

  return [useCallback(function (_ref2) {
    var marketingSource = _ref2.marketingSource,
        data = _objectWithoutProperties(_ref2, _excluded);

    return flixApiV2('post', 'member/register', _objectSpread(_objectSpread({}, data), {}, {
      marketingSource: marketingSource ? encodeURIComponent(marketingSource) : ''
    })).then(function (authStatus) {
      writeAuthStatusQuery(client, authStatus);
      events.emit(REGISTERED, authStatus);
      onCompleted && onCompleted(authStatus);
    }).catch(function (error) {
      return error.errors;
    });
  }, [client, events, flixApiV2, onCompleted])];
};